angular
	.module 'App.Repository'
	.factory 'TicketEventRepository', ['BaseRepository', (BaseRepository) ->
		class TicketEventRepository extends BaseRepository
			@resource = '/ticket_events'
			@isRestricted = true

		return new TicketEventRepository
	]
